//-- Copyright (c) 2021 TMT Insights Group, LLC
import React from 'react';
import { Link } from 'react-router-dom';
import { Grid } from '@mui/material';
import { Breadcrumbs, Title, TitleBar } from '@/components/_common';
import { clearFilters } from '@/redux/slices/dataTableSlice';
import { selectDataTableAppliedSearchName, selectTableTitle } from '@/redux/selectors/dataTableSelectors';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';

const PendingAssetsTitleBar = () => {
  const dispatch = useAppDispatch();
  const appliedSearchName = useAppSelector(selectDataTableAppliedSearchName);
  const pageTitle = useAppSelector(selectTableTitle) || 'Pending Assets';

  const onBreadcrumbsClick = () => {
    dispatch(clearFilters());
  };

  return (
    <TitleBar>
      <Grid container justifyContent="space-between" alignItems="center">
        {!appliedSearchName ? (
          <Title>{pageTitle}</Title>
        ) : (
          <Breadcrumbs aria-label="breadcrumb">
            <Link to="/pending-assets" onClick={onBreadcrumbsClick}>
              {pageTitle}
            </Link>
            <span>&ldquo;{appliedSearchName}&ldquo;</span>
          </Breadcrumbs>
        )}
      </Grid>
    </TitleBar>
  );
};

export default PendingAssetsTitleBar;
